import localeData from './locale-data.js';
import locales, { localeMap, isRtl } from './supported-locales.js';
export { locales as default, localeData, localeMap, isRtl };
